// extracted by mini-css-extract-plugin
export default {"kliksRow":"style_kliksRow__N-pm6","subColWrapper":"style_subColWrapper__RRrK2"};